import { Component, OnInit } from '@angular/core';
import { AgilityRiskService } from '../../../providers/agility-risk.service';
import { TranslateService } from '@ngx-translate/core';
import { Assessment } from '../../../models/assessment';
import { AssessmentDistribution } from '../../../models/assessment-distribution';
import { ActivatedRoute } from '@angular/router';
import 'chartjs-plugin-annotation';
import { AssessmentSummary } from '../../../models/assessment-summary';
import { RiskBand } from '../../../models/risk-band';
import { GetRiskAssessmentSummaryResponse } from '../../../models/get-risk-assessment-summary-response';

@Component({
  selector: 'lib-risk-assessment-summary',
  templateUrl: './risk-assessment-summary.component.html',
  styleUrls: ['./risk-assessment-summary.component.scss']
})
export class RiskAssessmentSummaryComponent implements OnInit {
  public threatsHorizontalChartData: any;
  public threatsHorizontalChartOptions: any;
  public assessment: Assessment = new Assessment();
  public distributionId: string;
  public assessmentDistribution: AssessmentDistribution;
  public riskAssessmentSummaries: Array<AssessmentSummary> = [];
  public annotations = [];
  public assessmentSummary: AssessmentSummary;

  constructor(private agilityRiskService: AgilityRiskService,
              private translateService: TranslateService,
              private activatedRoute: ActivatedRoute) {
    this.distributionId = this.activatedRoute.snapshot?.params?.id;
  }

  ngOnInit(): void {
    this.getAssessmentDistribution();
  }

  getAssessmentDistribution() {
    this.agilityRiskService.getAssessmentDistribution(this.distributionId)
      .subscribe((assessmentDistribution: AssessmentDistribution) => {
        this.assessmentDistribution = assessmentDistribution;
        this.assessment = this.assessmentDistribution.riskAssessment;
        this.defineAnnotations();
        this.getRiskAssessmentSummary();
        this.getAssessmentSummary();
      });
  }

  getRiskAssessmentSummary() {
    this.agilityRiskService.getRiskAssessmentSummary(this.assessment.id)
      .subscribe((assessmentSummaries: GetRiskAssessmentSummaryResponse) => {
        this.riskAssessmentSummaries = assessmentSummaries.riskSummaries;
        this.initChart();
      });
  }

  getAssessmentSummary() {
    this.agilityRiskService.getAssessmentSummary(this.assessment.id)
      .subscribe((assessmentSummary: AssessmentSummary) => {
        this.assessmentSummary = assessmentSummary;
      });
  }

  defineAnnotations(): void {
    this.assessment.riskBands.forEach((rb: RiskBand) => {
      this.annotations.push({
        drawTime: 'beforeDatasetsDraw',
        type: 'line',
        mode: 'vertical',
        scaleID: 'x-axis-0',
        value: rb.numericValue,
        borderColor: '#D3D3D3', // todo: what color?
        label: {
          enabled: true,
          content: rb.name,
          position: 'top',
          backgroundColor: 'rgb(255, 255, 255)',
          fontSize: 14,
          fontColor: 'rgb(0, 0, 0)',
          fontStyle: 'normal'
        }
      });
    });
  }

  initChart() {
    this.threatsHorizontalChartData = {
      labels: this.riskAssessmentSummaries.map((as: AssessmentSummary) => as.name),
      datasets: [
        {
          label: this.translateService.instant('common.criticality'),
          backgroundColor: '#FFB74D', // TODO: colors....
          data: this.riskAssessmentSummaries.map((as: AssessmentSummary) => as.rank),
          barThickness: 20
        }
      ]
    };

    this.threatsHorizontalChartOptions = {
      responsive: true,
      legend: {
        display: false
      },
      scales: {
        xAxes: [{
          gridLines: {
            drawOnChartArea: false,
            drawTicks: false,
          },
          scaleLabel: {
            display: true,
            labelString: this.translateService.instant('common.criticality'),
            fontSize: 16,
            fontStyle: 'bold'
          },
          ticks: {
            min: 0,
            max: this.assessment.riskBands[this.assessment.riskBands.length - 1]?.numericValue + 5, // give it dead space to the right so annotation label won't get cut off
            stepSize: 1,
            beginAtZero: true,
            display: false
          }
        }],
        yAxes: [{
          gridLines: {
            drawOnChartArea: false,
            drawTicks: false,
          },
          ticks: {
            padding: 10,
            fontSize: 14
          }
        }]
      },
      annotation: {
        annotations: this.annotations
      }
    };
  }
}
